const inlineFilterItems = [
  {
    id: 'all',
    label: 'Semua',
  },
  {
    id: 'DRAFT',
    label: 'Draf',
  },
  {
    id: 'CONFIRMED',
    label: 'Dikonfirmasi',
  },
  {
    id: 'EXPIRED',
    label: 'Kadaluwarsa',
  },
  {
    id: 'CANCELED',
    label: 'Dibatalkan',
  },
  {
    id: 'CLOSED',
    label: 'Ditutup',
  },
]

export default inlineFilterItems
